module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="base-form">\n	<h1>LINK '+
((__t=( game_title ))==null?'':_.escape(__t))+
' ACCOUNT</h1>\n	<p>We have detected that your NRL Account registered email was used to play '+
((__t=( game_title ))==null?'':_.escape(__t))+
'</p>\n	<div class="form-group">\n		<input type="text" id="email" value="'+
((__t=( email ))==null?'':_.escape(__t))+
'" disabled>\n		<button type="button" class="btn-text under-field-text js-link-to-different-account">I\'d prefer to link to a different '+
((__t=( game_title ))==null?'':_.escape(__t))+
' account</button>\n	</div>\n	<p>This means in future you will use your new NRL Account as your '+
((__t=( game_title ))==null?'':_.escape(__t))+
' login, but your previous team and league history will be retained.</p>\n	<div class="buttons-wrapper">\n		<button type="submit" class="btn primary-btn js-next">Next</button>\n	</div>\n</form>';
}
return __p;
};
